<script setup lang="ts">
</script>
<template>
    <table class="table table-condensed action-card-table">
        <tbody>
            <slot />
        </tbody>
    </table>
</template>
<style scoped>
.action-card-table {
    margin-bottom: 0px;
}
</style>
